import React from 'react';
import { FileText } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
import { Card, CardContent } from '../../ui/card';
import DocumentListTableRow, { Document } from './DocumentListTableRow';

interface DocumentListTableProps {
  documents: Document[];
  moduleColors: Record<string, string>;
  statusColors: Record<string, string>;
}

export default function DocumentListTable({
  documents,
  moduleColors,
  statusColors,
}: DocumentListTableProps) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Nama Dokumen</TableHead>
              <TableHead>Entitas</TableHead>
              <TableHead>Modul</TableHead>
              <TableHead>No. Ref</TableHead>
              <TableHead>Upload</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Aksi</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {documents.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} className="text-center py-8 text-gray-500">
                  <FileText className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                  Tidak ada dokumen
                </TableCell>
              </TableRow>
            ) : (
              documents.map(doc => (
                <DocumentListTableRow
                  key={doc.id}
                  document={doc}
                  moduleColors={moduleColors}
                  statusColors={statusColors}
                />
              ))
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
